import { BaseContainerModel } from "../base-container.model";
import { bl_wms_container_hdr_RowInterface, bl_wms_container_hdr_RowClass } from "../../dbschema/index";

export class WarehouseContainerHdrModel extends BaseContainerModel {
    bl_wms_container_hdr: bl_wms_container_hdr_RowInterface = new bl_wms_container_hdr_RowClass();
}
